"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaytripClientFromHeader = getDaytripClientFromHeader;
const legacy_enums_1 = require("@daytrip/legacy-enums");
/**
 * DUPLICATED packages/api-core/src/app-client/app-client.provider.ts
 */
function getDaytripClientFromHeader(clientTypeHeader, clientPlatformHeader) {
    // X-Daytrip-Client-Platform: platform
    const hasNoClientTypeHeader = !clientTypeHeader || Array.isArray(clientTypeHeader);
    const hasNoClientPlatformHeader = !clientPlatformHeader || Array.isArray(clientPlatformHeader);
    if (hasNoClientTypeHeader) {
        return { name: legacy_enums_1.ClientType.Unknown };
    }
    // X-Daytrip-Client: (client) (version)-(revision)
    const [name, versionWithRevision] = clientTypeHeader.split(" ");
    const [version, revision] = versionWithRevision?.split("-") ?? [];
    if (hasNoClientPlatformHeader) {
        return {
            name,
            version,
            revision,
        };
    }
    const platform = clientPlatformHeader;
    return {
        name,
        version,
        revision,
        platform,
    };
}
//# sourceMappingURL=getDaytripClientFromHeader.js.map